import { createStyles } from "@material-ui/core/styles";

const Styles = createStyles({});

export default Styles;
